module.exports = __webpack_public_path__ + "img/im_scrollfeature_13@2x.2c785c7d.jpg";